/**
 * useHeartbeat
 * ------------------------------------------------------------
 * Single global setInterval that drives the virtual clock and
 * notifies subscribers (DaySimulator). Mount once in App root.
 *
 * Real interval: 1000ms.
 * Virtual delta = 1000ms * speed.
 */
import { useEffect } from 'react';
import { useVirtualClock } from '@/stores/useVirtualClock';

type Subscriber = (virtualTime: Date, deltaMs: number) => void;

const subscribers = new Set<Subscriber>();

export function subscribeToHeartbeat(fn: Subscriber): () => void {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

export function useHeartbeat() {
  useEffect(() => {
    const id = window.setInterval(() => {
      const { speed, tick } = useVirtualClock.getState();
      if (speed === 0) return;
      const deltaMs = 1000 * speed;
      tick(deltaMs);
      const now = useVirtualClock.getState().virtualTime;
      subscribers.forEach((fn) => {
        try {
          fn(now, deltaMs);
        } catch (err) {
          console.error('[Heartbeat] subscriber error', err);
        }
      });
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
}
